import languages from "../languages/schema"

export default {
    "type": "object",
    "properties": {
        "content": {
            "type": "object",
            "properties": {
                "title": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "email": {
                    "type": "string"
                },
                "phone": {
                    "type": "string"
                },
                "languages": languages,
                "description": {
                    "type": "string"
                },
                "places": {
                    "type": "array",
                    "items": {
                        "type": "reference",
                        "referenceType": "place",
                        "documentType": "place",
                        "_reverseReferenceType": "person",
                        "_reverseReference": "people[]"
                    }
                }
            }
        }
    }
}